import React, { HTMLProps } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'src/store';
import cn from 'classnames';
import './styles.scss';
import { Text, View } from 'src/components/common';
import { getFileIcon } from 'src/utils/fileUtils';
import { Image } from 'src/components/common';
import { FileData } from 'src/dataFactory/depositionFactory';

const DepositionItemFileName: React.FC<Props> = ({ file, className, ...props }) => {
  return (
    <View
      isRow
      className={cn('cmp-depo-item-file-name', className)}
      data-tooltip={`${file.name}.${file.extension}`}
      {...props}>
      <Image className="cmp-depo-item-file-name__icon" src={getFileIcon(file.extension ?? '')} />
      <Text size={14} className="cmp-depo-item-file-name__text">
        <span className="cmp-depo-item-file-name__file-name">{file.name}</span>.{file.extension}
      </Text>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  HTMLProps<HTMLDivElement> & {
    file: FileData;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DepositionItemFileName);
